// React
import React, { Fragment } from "react";

// Ant Design Components
import { Popconfirm, Table } from "antd";

// Custom UI Components
import H3Text from "@Uilib/h3Text";

// Helpers & Constants
import { getRequiredColumns } from "../helper";

function ViewOutgoingPaymentTables({
  selectedPaymentOutgoing,
  selectPaymentTenant,
  poColumns,
  dnColumns,
  tableColumns,
  cnColumns,
  apInvoiceColumns,
  screen,
  tableTitle,
  unLinkPaymentLoading,
  unlinkPOAdvancePayment,
  getPaymentOutgoingById,
  selectedPaymentId,
  user,
  unlinkPOAdvancePaymentLoading,
  dataSource,
}) {
  return (
    <Fragment>
      {selectedPaymentOutgoing?.linked_po?.length > 0 && (
        <Fragment>
          <Table
            bordered
            showHeader
            title={() =>
              `LINKED PURCHASE ORDER (${
                selectedPaymentOutgoing?.linked_po?.length || "0"
              })`
            }
            size="small"
            columns={
              selectPaymentTenant
                ? poColumns
                : [
                    ...poColumns,
                    {
                      title: "",
                      responsive: ["sm", "md", "lg", "xxl"],
                      render: (record) => (
                        <Fragment>
                          {!selectedPaymentOutgoing?.zoho_bill_payment_id &&
                          !selectedPaymentOutgoing?.tally_bill_payment_number ? (
                            <Popconfirm
                              placement="topRight"
                              title="Are you sure to unlink this payment? "
                              onConfirm={() => {
                                unlinkPOAdvancePayment(
                                  {
                                    payment_id:
                                      selectedPaymentOutgoing.payment_id,
                                  },
                                  () => {
                                    getPaymentOutgoingById(
                                      Helpers.getTenantEntityPermission(
                                        user?.user_tenants,
                                        Helpers.permissionEntities
                                          .VENDOR_PAYOUT,
                                        Helpers.permissionTypes.READ
                                      ).join(","),
                                      selectedPaymentId
                                    );
                                  }
                                );
                              }}
                              okText="Yes"
                              cancelText="No"
                              loading={unlinkPOAdvancePaymentLoading}
                            >
                              <div className="payment-unlink-button">
                                Unlink Payment
                              </div>
                            </Popconfirm>
                          ) : (
                            <H3Text text="Payments imported from Tally/Zoho cannot be updated" />
                          )}
                        </Fragment>
                      ),
                    },
                  ]
            }
            dataSource={selectedPaymentOutgoing?.linked_po || []}
            pagination={false}
            scroll={{ x: true }}
            loading={unlinkPOAdvancePaymentLoading}
          />
          <br />
        </Fragment>
      )}
      <Table
        bordered
        showHeader
        title={() => tableTitle}
        size="small"
        columns={getRequiredColumns({
          screen,
          selectedPaymentOutgoing,
          dnColumns,
          tableColumns,
          cnColumns,
          apInvoiceColumns,
        })}
        dataSource={dataSource}
        pagination={false}
        scroll={{ x: true }}
        loading={unLinkPaymentLoading}
      />
    </Fragment>
  );
}

export default ViewOutgoingPaymentTables;
